export default [{  //资产档案列表
		path: 'fixed_asset',
		name: 'm_fixed_asset',
		meta: {
			appView: {
				viewId: '10006',
				auth: 'b_fixed_asset_viewmanage'
			}
		},
		component: () => import('@/pages/asset/fixed_asset_list.vue')
	},
	{  //资产领用
		path: 'asset_receive_apply',
		name: 'm_asset_receive',
		meta: {
			appView: {
				viewId: '10007',
				auth: 'b_asset_receive_viewmanage'
			}
		},
		component: () => import('@/pages/asset/asset_receive_apply_list.vue')
	},
	{  //资产归还
		path: 'asset_return_apply',
		name: 'm_asset_return',
		meta: {
			appView: {
				viewId: '10013',
				auth: 'b_asset_return_viewmanage'
			}
		},
		component: () => import('@/pages/asset/asset_return_apply_list.vue')
	},
	{  //维修记录
		path: 'asset_repair',
		name: 'm_asset_repair',
		meta: {
			templateManage: {
				workType: 16,
				print: 'b_asset_repair_printtemplate',
				export: 'b_asset_repair_exporttemplate'
			},
			appView: {
				viewId: '10016',
				auth: 'b_asset_repair_viewmanage'
			}
		},
		component: () => import('@/pages/asset/asset_repair_record_list.vue')
	},
];